import React from 'react';
import PropTypes from 'prop-types';
import { usePrefs } from 'wsm-common-data';
import { setClassNames } from 'ddc-classnames-js';

const Container = ({ children }) => {
	const { imageHorizontalAlignment, imageVerticalAlignment } = usePrefs();

	return (
		<div
			className={setClassNames([
				'w-100',
				'h-100',
				'd-flex',
				imageHorizontalAlignment,
				imageVerticalAlignment
			])}
		>
			{children}
		</div>
	);
};

Container.propTypes = {
	children: PropTypes.element
};

export default Container;
